import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { toString1pkumu07cwy4m as toString } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function stringSerializer(deserializationStrategy) {
  return new (stringSerializer$1())(deserializationStrategy);
}
function stringSerializer$o$_get_descriptor_$ref_wan83j() {
  return (p0) => p0.a1n();
}
var stringSerializer$1Class;
function stringSerializer$1() {
  if (stringSerializer$1Class === VOID) {
    class $ {
      constructor($deserializationStrategy) {
        this.g29_1 = $deserializationStrategy;
        var tmp = this;
        tmp.f29_1 = lazy(() => $deserializationStrategy.a1n());
      }
      a1n() {
        var tmp0 = this.f29_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('descriptor', 1, tmp, stringSerializer$o$_get_descriptor_$ref_wan83j(), null);
        return tmp0.n3();
      }
      u1n(encoder, value) {
        return encoder.w1s(toString(value));
      }
      b1n(encoder, value) {
        return this.u1n(encoder, !(value == null) ? value : THROW_CCE());
      }
      c1n(decoder) {
        return this.g29_1.c1n(decoder);
      }
    }
    initMetadataForClass($, VOID, VOID, VOID, [KSerializer()]);
    stringSerializer$1Class = $;
  }
  return stringSerializer$1Class;
}
//region block: exports
export {
  stringSerializer as stringSerializer3fqetsvttr56r,
};
//endregion

//# sourceMappingURL=Serializers.mjs.map
